import validate from "/home/danieluhm2004/workspace/Playkeyboard_Webview/node_modules/nuxt/dist/pages/runtime/validate.js";
import manifest_45route_45rule from "/home/danieluhm2004/workspace/Playkeyboard_Webview/node_modules/nuxt/dist/app/middleware/route-rules.js";
export const globalMiddleware = [
  validate,
  manifest_45route_45rule
]
export const namedMiddleware = {
  auth: () => import("/home/danieluhm2004/workspace/Playkeyboard_Webview/middleware/auth.ts")
}